import { render, staticRenderFns } from "./Google2FA.vue?vue&type=template&id=591e30c2&"
import script from "./Google2FA.vue?vue&type=script&lang=js&"
export * from "./Google2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports